/* ============================================================
   sm-hafa-samband.js - skrá með fyrirspurn á /pages/contact

   Contact-formið (Shopify) tekur ekki við skrám. Leiðin án apps:
     1. Viðskiptavinur velur skrá í sm-skra reitnum (snippets/sm-skra.liquid).
     2. Skráin fer strax í multipart POST /cart/add.js sem eiginleikinn
        properties[Skrá] á földu hjálparvöruna "Skrá með fyrirspurn"
        (UNLISTED, 0 kr, ekki seld). Shopify geymir skrána og svarar með
        CDN-slóð í properties.
     3. Línan er fjarlægð STRAX (/cart/change.js, quantity 0, með line key) og
        að lokum er karfan sótt og athugað að engin hjálparlína sé eftir.
     4. Slóðin fer í falda reitinn contact[Skrá] og formið sendist eins og áður.

   XMLHttpRequest en ekki fetch, viljandi: sm-hurda-flow.js vefur fetch og
   opnar "Bætt í körfu" skúffuna fyrir hvert vel heppnað /cart/add. Með XHR
   sést hjálparvaran aldrei.

   Varnir:
   - Karfa viðskiptavinar er óbreytt. Línur eru munaðar fyrir og athugaðar eftir;
     aðeins línur hjálparvörunnar eru nokkurn tíma fjarlægðar.
   - Bregðist eitthvað fer formið samt, með textanum "Skrá náðist ekki að senda,
     sendu hana á sm@skiltiogmerkingar.is", og eigandinn sér í póstinum að
     skrá átti að fylgja.
   - Þrýst á Senda á meðan skráin er á leiðinni: formið bíður og sendist sjálft.
   - Hjálparlína sem varð eftir (flipi lokaður á ögurstundu) er fjarlægð við
     næstu hleðslu þessarar síðu og á körfusíðunni.
   - Hlustar ekki á sm:karfa (sm-magnafslattur.js sendir hann eftir hverja
     /cart beiðni) og sendir engan sjálfur.
   ============================================================ */
(function () {
  'use strict';
  /* Enska (/en): textarnir koma úr JSON-blokk (script[data-sm-ord="samband"], aðeins utan aðaltungumáls); íslenskan er varagildið, svo íslensk hegðun er óbreytt. */
  var ORD = {};
  try { var oe = document.querySelector('script[data-sm-ord="samband"]'); if (oe) ORD = JSON.parse(oe.textContent) || {}; } catch (e) { ORD = {}; }
  function tx(k, fb, v) {
    var s = (typeof ORD[k] === 'string' && ORD[k]) ? ORD[k] : fb;
    if (v) { for (var n in v) { if (Object.prototype.hasOwnProperty.call(v, n)) s = s.split('{' + n + '}').join(v[n]); } }
    return s;
  }
  var rot = document.querySelector('[data-sm-hs]');
  if (!rot || !window.Promise) return;

  var form = rot.closest('form');
  var reitur = rot.querySelector('[data-sm-skra]');
  var slodReitur = rot.querySelector('[data-sm-hs-slod]');
  var stadaEl = rot.querySelector('[data-sm-hs-stada]');
  var takki = form ? form.querySelector('[data-sm-hs-senda]') : null;
  if (!form || !reitur || !slodReitur || !stadaEl) return;

  var VARIANT = parseInt(rot.getAttribute('data-variant'), 10);
  var POSTUR = rot.getAttribute('data-sub') || 'sm@skiltiogmerkingar.is';
  var R = window.routes || {};
  var ADD = (R.cart_add_url || '/cart/add') + '.js';
  var CHANGE = (R.cart_change_url || '/cart/change') + '.js';
  var UPDATE = ((R.cart_url || '/cart').replace(/\/$/, '')) + '/update.js';
  var CART = ((R.cart_url || '/cart').replace(/\/$/, '')) + '.js';
  var MB = 1048576;
  var TIMI = 240000;
  var NEI_TEXTI = tx('nei_texti', 'Skrá náðist ekki að senda, sendu hana á {postur}', { postur: POSTUR });

  var st = { nr: 0, bid: false, bidaSendingar: false, takkiTexti: null };

  /* ---------- Hjálp ---------- */
  function xhr(adferd, slod, body, json) {
    return new Promise(function (leysa, hafna) {
      var x = new XMLHttpRequest();
      x.open(adferd, slod, true);
      x.timeout = TIMI;
      x.setRequestHeader('Accept', 'application/json');
      if (json) x.setRequestHeader('Content-Type', 'application/json');
      x.onload = function () {
        var d = null;
        try { d = JSON.parse(x.responseText); } catch (e) {}
        leysa({ status: x.status, json: d });
      };
      x.onerror = function () { hafna(new Error('net')); };
      x.ontimeout = function () { hafna(new Error('timi')); };
      x.send(body);
    });
  }
  function karfan() {
    return xhr('GET', CART + '?_=' + Date.now(), null).then(function (r) {
      if (r.status !== 200 || !r.json || !r.json.items) throw new Error('karfa');
      return r.json;
    });
  }
  function erHjalp(lina) { return lina && lina.variant_id === VARIANT; }
  function kr(baeti) {
    if (baeti < MB) return Math.max(1, Math.round(baeti / 1024)) + ' KB';
    return (Math.round(baeti / MB * 10) / 10).toString().replace('.', ',') + ' MB';
  }

  /* Allar hjálparlínur út. Skilar lyklum sem eftir standa. */
  function hreinsa(karfa) {
    var lyklar = (karfa.items || []).filter(erHjalp).map(function (l) { return l.key; });
    if (!lyklar.length) return Promise.resolve([]);
    var uppf = {};
    lyklar.forEach(function (k) { uppf[k] = 0; });
    return xhr('POST', UPDATE, JSON.stringify({ updates: uppf }), true).then(function () {
      return karfan().then(function (k2) { return (k2.items || []).filter(erHjalp); });
    });
  }

  function fjarlaegjaLinu(lykill) {
    return xhr('POST', CHANGE, JSON.stringify({ id: lykill, quantity: 0 }), true).then(function (r) {
      if (r.status >= 400) throw new Error('change');
    });
  }

  /* Karfa viðskiptavinar má ekki breytast: línur (án hjálparlínu) fyrir og eftir. */
  function lysing(karfa) {
    var m = {};
    (karfa.items || []).forEach(function (l) { if (!erHjalp(l)) m[l.key] = l.quantity; });
    return m;
  }
  function jafnt(a, b) {
    var ka = Object.keys(a), kb = Object.keys(b);
    if (ka.length !== kb.length) return false;
    return ka.every(function (k) { return a[k] === b[k]; });
  }

  /* ---------- Stöðutexti og form ---------- */
  function segja(texti, tegund) {
    stadaEl.hidden = !texti;
    stadaEl.textContent = texti || '';
    if (tegund) stadaEl.setAttribute('data-ok', tegund);
    else stadaEl.removeAttribute('data-ok');
  }
  function setjaGildi(gildi) {
    slodReitur.value = gildi || '';
    slodReitur.disabled = !gildi;
  }
  function takkiBid(bid) {
    if (!takki) return;
    if (bid) {
      if (st.takkiTexti === null) st.takkiTexti = takki.innerHTML;
      takki.disabled = true;
      takki.setAttribute('aria-busy', 'true');
      takki.textContent = tx('sendi', 'Sendi skrá...');
    } else if (st.takkiTexti !== null) {
      takki.disabled = false;
      takki.removeAttribute('aria-busy');
      takki.innerHTML = st.takkiTexti;
      st.takkiTexti = null;
    }
  }
  function lokid() {
    st.bid = false;
    if (st.bidaSendingar) {
      st.bidaSendingar = false;
      takkiBid(false);
      /* Formið sendist eins og áður; requestSubmit keyrir innbyggða sannprófun. */
      if (form.requestSubmit) form.requestSubmit(takki || undefined);
      else form.submit();
    }
  }

  /* ---------- Upphleðsla ---------- */
  function mistokst(skra, nr, ordsaga) {
    if (nr !== st.nr) return;
    if (window.console && console.warn) console.warn('sm-hafa-samband:', ordsaga);
    setjaGildi('Skrá fylgdi ekki (upphleðsla mistókst): ' + skra.name + ', ' + kr(skra.size));
    segja(NEI_TEXTI, 'villa');
    lokid();
  }

  function hladaUpp(skra) {
    var nr = ++st.nr;
    setjaGildi('');
    segja(tx('sendi', 'Sendi skrá...'), '');
    st.bid = true;
    var fyrir = null;
    var linaLykill = null;

    var fd = new FormData();
    fd.append('id', String(VARIANT));
    fd.append('quantity', '1');
    fd.append('properties[Skrá]', skra, skra.name);

    karfan().then(function (k) {
      fyrir = lysing(k);
      /* Hjálparlína frá fyrri tilraun má ekki vera fyrir. */
      return hreinsa(k);
    }).then(function () {
      return xhr('POST', ADD, fd, false);
    }).then(function (r) {
      var j = r.json;
      if (r.status === 413) { var e = new Error('413'); e.stor = true; throw e; }
      if (r.status >= 400 || !j || !j.key) throw new Error('add ' + r.status);
      linaLykill = j.key;
      var url = j.properties && j.properties['Skrá'];
      if (typeof url !== 'string' || url.indexOf('https://') !== 0) {
        /* Línan er komin en slóðin vantar: fjarlægð hér að neðan og villa sýnd. */
        url = null;
      }
      /* Línan út STRAX, óháð því hvað kemur næst. */
      return fjarlaegjaLinu(linaLykill).then(function () { return url; }, function () {
        /* Reynum aftur með update.js; hreinsunin hér að neðan er síðasta vörnin. */
        var u = {}; u[linaLykill] = 0;
        return xhr('POST', UPDATE, JSON.stringify({ updates: u }), true).then(function () { return url; });
      });
    }).then(function (url) {
      return karfan().then(function (k) { return hreinsa(k).then(function (eftir) { return { url: url, k: k, eftir: eftir }; }); });
    }).then(function (n) {
      /* Slóðin er til og skráin geymd, svo hún fylgir þótt línan sitji eftir; hún er fjarlægð við næstu hleðslu. */
      if (n.eftir.length && window.console && console.warn) console.warn('sm-hafa-samband: hjálparlína sat eftir í körfu');
      return karfan().then(function (k2) {
        if (fyrir && !jafnt(fyrir, lysing(k2)) && window.console && console.warn) console.warn('sm-hafa-samband: karfan breyttist á meðan (annar flipi?)');
        return n.url;
      });
    }).then(function (url) {
      if (nr !== st.nr) return;
      if (!url) throw new Error('engin slod');
      setjaGildi(url);
      segja(tx('mottekin', 'Skrá móttekin. Hún fylgir skilaboðunum.'), 'ok');
      lokid();
    })['catch'](function (e) {
      /* Reyna að skilja körfuna eftir hreina, hvað sem gerðist. */
      var upphaf = linaLykill ? karfan().then(hreinsa) : Promise.resolve();
      upphaf['catch'](function () {});
      if (nr !== st.nr) return;
      if (e && e.stor) {
        mistokst(skra, nr, '413');
        segja(tx('of_stor', 'Skráin er of stór til að senda. Hún má mest vera 19 MB.') + ' ' + NEI_TEXTI, 'villa');
        return;
      }
      mistokst(skra, nr, e && e.message);
    });
  }

  /* ---------- Tenging við sm-skra ---------- */
  function byrja() {
    var inn = reitur.querySelector('[data-sm-skra-inntak]');
    /* Skráin fer ekki með forminu sjálfu (það er ekki multipart); nafnið burt svo ekki fljóti með tómt skráarnafn. */
    if (inn) inn.removeAttribute('name');
    window.SMSkra.syna(reitur, true);

    reitur.addEventListener('sm:skra', function (e) {
      var skra = e.detail && e.detail.skra;
      st.nr++;
      st.bid = false;
      if (st.bidaSendingar) { st.bidaSendingar = false; takkiBid(false); }
      setjaGildi('');
      segja('');
      if (skra) hladaUpp(skra);
    });

    form.addEventListener('submit', function (e) {
      if (!st.bid) return;
      /* Skráin er enn á leiðinni: bíða og senda sjálfkrafa þegar hún er komin. */
      e.preventDefault();
      if (st.bidaSendingar) return;
      st.bidaSendingar = true;
      takkiBid(true);
    });

    /* Hjálparlína sem varð eftir frá fyrri heimsókn. */
    karfan().then(hreinsa)['catch'](function () {});
  }

  if (window.SMSkra) byrja();
  else window.addEventListener('load', function () { if (window.SMSkra) byrja(); });
})();
